import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import InviteForm from 'components/team/InviteForm';
import StyledModalHeader from 'components/modal/StyledModalHeader';

import { createAndInviteUsers, getEligibleMembers } from 'actions/Team';

import { clearModal } from 'actions';

import { Modal, ModalBody } from 'reactstrap';

const InviteTeamAdminsModal = ({
  team,
  eligibleMembers,
  modalOpen,
  clearModal,
  getEligibleMembers,
  createAndInviteUsers,
}) => {
  useEffect(() => {
    if (modalOpen) {
      getEligibleMembers();
    }
  }, [getEligibleMembers, modalOpen]);

  const clearInviteModal = clearModal.bind(null, 'TEAM_INVITE_ADMINS');

  const contentReady = team ? true : false;

  return (
    <Modal isOpen={modalOpen} toggle={clearInviteModal}>
      <StyledModalHeader toggle={clearInviteModal}>
        Invite team admins
      </StyledModalHeader>
      <ModalBody>
        {contentReady && (
          <InviteForm
            crewAutoCompleteOptions={eligibleMembers}
            onSubmit={(users) => {
              createAndInviteUsers(users);

              clearInviteModal();
            }}
            onCancel={clearInviteModal}
          />
        )}
      </ModalBody>
    </Modal>
  );
};

export default connect(
  ({ modal, team, teamEligibleMembers }) => {
    const props = {
      team,
      eligibleMembers: teamEligibleMembers,
      modalOpen: modal && modal.type === 'TEAM_INVITE_ADMINS',
    };

    if (props.modalOpen) {
      return { ...props, ...modal.initialValue };
    }

    return props;
  },
  {
    clearModal,
    getEligibleMembers,
    createAndInviteUsers,
  },
)(InviteTeamAdminsModal);
